import { render, staticRenderFns } from "./reg-subscribe.vue?vue&type=template&id=6f8a6782"
import script from "./reg-subscribe.vue?vue&type=script&lang=js"
export * from "./reg-subscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports